import { css } from '@emotion/core'

export const sizeIcon = css`
  font-size: 1rem;
  margin: 0 5px;
`
